import { Fragment } from 'react';
import Footer from '../shared/footer';
import Header2 from '../shared/header2';
import MainConent from './main-content';
import VerticalBar from './vertical-bar';

const GeneralInformation = () => (
  <Fragment>
    <Header2 />
    <main className='min-h-[1000px] min-w-[1052px]'>
      <div className='my-[28px]'>
        <div className='container mx-auto flex min-w-[1052px] space-x-[24px] px-[54px] screen-1140:px-[98px] xl:px-[48px] screen-1366:px-[83px]'>
          <MainConent />
          <VerticalBar />
        </div>
      </div>
    </main>
    <Footer />
  </Fragment>
);

export default GeneralInformation;
